import type React from 'react';

import {
  useDropdownContext,
  DropdownContext,
  DropdownMenu,
  Iconify,
} from '@mfw/components';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';

import './NotificationsCenter.scss';

export interface NotificationsCenterProps {
  children?: React.ReactNode;
  onOpen?: () => void;
  title?: string;
  badge?: number;
}
const NotificationsCenterWrapper = ({
  badge,
  children,
  onOpen,
  title,
}: NotificationsCenterProps) => {
  const { getReferenceProps, refs, setOpen } = useDropdownContext();
  return (
    <div>
      <Badge badgeContent={badge} color="primary">
        <IconButton
          onClick={() => {
            setOpen((prev) => {
              if (!prev) onOpen?.();
              return !prev;
            });
          }}
          ref={(e) => {
            refs.setReference(e);
          }}
          data-testid="notifications-center-toggle"
        >
          <Iconify
            icon="material-symbols:notifications"
            size="medium"
            {...getReferenceProps()}
          />
        </IconButton>
      </Badge>
      <DropdownMenu
        classes={{ content: 'Mfw-NotificationsCenter-dropdownMenuContent' }}
        title={title ?? ''}
      >
        {children}
      </DropdownMenu>
    </div>
  );
};

export const NotificationsCenter = ({
  children,
  onOpen,
  ...props
}: NotificationsCenterProps) => {
  return (
    <DropdownContext>
      <NotificationsCenterWrapper {...props} onOpen={onOpen}>
        {children}
      </NotificationsCenterWrapper>
    </DropdownContext>
  );
};
